//
// With information from
// https://alligator.io/vuejs/vuefire-firebase/
//

import Firebase from 'firebase'

const firebaseApp = Firebase.initializeApp({
  apiKey: "AIzaSyCGjR151Se4KrWVLJEBDwjWyBAnzpDd4JM",
  authDomain: "vuefire-login-howto.firebaseapp.com",
  databaseURL: "https://vuefire-login-howto.firebaseio.com",
  projectId: "vuefire-login-howto",
  storageBucket: "vuefire-login-howto.appspot.com",
  messagingSenderId: "575487551619"
});

// Export the database for components to use.
export const db = firebaseApp.database();

// Just for Dev use.
Firebase.auth().onAuthStateChanged(firebaseUser => {
    if (firebaseUser) {
        console.log(firebaseUser.uid + ' is logged in');
    } else {
        console.log('Not logged in');
    }
})



// WEBPACK FOOTER //
// ./src/firebaseConf.js